import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Warning, ArrowRight } from "@phosphor-icons/react";

/* AlertsStrip — pinned low-stock warning banner. Polls /alerts on mount and
   whenever the parent triggers a reload via the `onReload` prop. */
export function AlertsStrip({ onReload }) {
    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        api.get("/admin/inventory/alerts").then((r) => setAlerts(r.data || [])).catch(() => {});
    }, [onReload]);

    if (alerts.length === 0) return null;

    return (
        <div className="rounded-2xl border-2 border-rose-200 bg-rose-50 px-5 py-3" data-testid="inventory-alerts-strip">
            <div className="flex items-center gap-3">
                <Warning size={22} weight="fill" className="text-rose-700 shrink-0" />
                <div className="flex-1 min-w-0">
                    <div className="font-semibold text-rose-900 text-sm">
                        {alerts.length} material{alerts.length === 1 ? "" : "s"} at or below reorder threshold
                    </div>
                    <div className="text-xs text-rose-800/80 mt-0.5 truncate">
                        {alerts.slice(0, 3).map((a) => `${a.sku} (${a.current_stock}/${a.reorder_threshold} ${a.unit})`).join(" · ")}
                        {alerts.length > 3 && ` · +${alerts.length - 3} more`}
                    </div>
                </div>
                <ArrowRight size={14} className="text-rose-700 shrink-0" />
            </div>
        </div>
    );
}
